import { Form, FormInstance, Input, Tree, TreeProps } from "antd";
import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../common/components/simpleInput";
import style from "./style.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { useQueryAllMenusForRoleForm } from "../hooks/_hooks";
import { Loader } from "../../../../common/components/Loader/Loader";
import Spinner from "../../../../common/components/Spinner/Spinner";
import { RoleServices } from "../core/_request";
import { HttpStatusCode } from "axios";

type PropsType = {
  initialValue?: any;
  onSuccess: () => void;
  type?: "read" | "update";
};

export const FormRole = ({ initialValue, onSuccess, type }: PropsType) => {
  const [form] = Form.useForm();
  const { setFieldValue } = form as FormInstance;

  const { data: menus, isLoading: isLoadingMenus } =
    useQueryAllMenusForRoleForm({
      pagination: false,
      "order[position]": "asc",
    });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);
  const [isRead, setIsRead] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      if (initialValue?.id) {
        getRole(initialValue?.id);
      }

      if (type && type === "read") {
        setIsRead(true);
      } else {
        setIsRead(false);
      }
    }
  }, [initialValue]);

  const onExpand: TreeProps["onExpand"] = (expandedKeysValue) => {
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onCheck: TreeProps["onCheck"] = (checkedKeysValue) => {
    setCheckedKeys(checkedKeysValue as React.Key[]);
    setFieldValue("menuRouteNames", checkedKeysValue);
  };

  const onSelect: TreeProps["onSelect"] = (selectedKeysValue) => {
    setSelectedKeys(selectedKeysValue);
  };

  const getRole = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await RoleServices.getRoleById(id);
      form.setFieldsValue(res?.data);
      setCheckedKeys(res?.data?.menuRouteNames);
      if (type && type === "read") {
        setExpandedKeys(res?.data?.menuRouteNames);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      const dataToPost = {
        ...(initialValue
          ? {
              id: initialValue?.id,
            }
          : {}),
        ...values,
      };

      if (!initialValue) {
        const res = await RoleServices.createRole(dataToPost);

        console.log(res);
        if (res?.status === HttpStatusCode.Created) {
          onSuccess();
        }
      } else {
        const res = await RoleServices.updateRoleById(dataToPost);

        if (res?.status === HttpStatusCode.Ok) {
          onSuccess();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <FormProvider
      Form={Form}
      form={form}
      debug
      onFinish={(values: any) => {
        handleSubmit(values);
      }}
      onFinishFailed={(err) => {
        console.log("err", err);
      }}
    >
      <Loader isLoading={isLoadingMenus || isLoading} />

      <div className={style.role__container}>
        <div className={style.role__content}>
          <div className="]">
            <SimpleInput
              Form={Form}
              name={"name"}
              label="Nom"
              rules={[
                {
                  required: true,
                  message: `Le champ Nom est requis`,
                },
              ]}
              customInput={
                <Input
                  placeholder={"Nom"}
                  className=" w-full "
                  disabled={isRead}
                />
              }
            />
          </div>
          <div className="">
            <SimpleInput
              Form={Form}
              label={"Description"}
              name={"description"}
              customInput={
                <Input.TextArea
                  placeholder={"Description"}
                  className=" w-full"
                  disabled={isRead}
                  rows={4}
                />
              }
            />
          </div>
        </div>

        <div className={style.role__content}>
          <div className={style.role__label}>Authorisations</div>
          <div className="">
            <SimpleInput
              Form={Form}
              name={"menuRouteNames"}
              customInput={
                <Tree
                  checkable
                  onExpand={onExpand}
                  expandedKeys={expandedKeys}
                  autoExpandParent={autoExpandParent}
                  onCheck={onCheck}
                  checkedKeys={checkedKeys}
                  onSelect={onSelect}
                  selectedKeys={selectedKeys}
                  treeData={menus}
                  disabled={isRead}
                />
              }
            />
          </div>
        </div>
      </div>
      {!isRead ? (
        <div className={style.role__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.role__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      ) : (
        ""
      )}
    </FormProvider>
  );
};
